(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3040],{

/***/ 38628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ CMSChildrenContainer; },
  "Z": function() { return /* binding */ ChildrenContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./utils/stylesHelper.ts
// Future improvement could be to add baseClasses as a potential array - either array or string
// if (Array.isArray(baseClass)) { return [...baseClass, className].join(" ")
function combineClasses(baseClass, className) {
    return className ? "".concat(baseClass, " ").concat(className) : baseClass;
}

// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/style.module.scss
var style_module = __webpack_require__(88460);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/ChildrenContainer/index.tsx




var CMSChildrenContainer = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: combineClasses((style_module_default()).childrenContainer, className),
        children: children
    });
};
/* harmony default export */ var ChildrenContainer = (CMSChildrenContainer);


/***/ }),

/***/ 23040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JobSnippet": function() { return /* binding */ JobSnippet; },
/* harmony export */   "JobSnippetStyle": function() { return /* binding */ JobSnippetStyle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _cmsComponents_ChildrenContainer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38628);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41749);
/* harmony import */ var _JobSnippet_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14327);
/* harmony import */ var _JobSnippet_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_JobSnippet_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var JobSnippetItem = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9669), __webpack_require__.e(4872), __webpack_require__.e(9043), __webpack_require__.e(7243), __webpack_require__.e(2628), __webpack_require__.e(933), __webpack_require__.e(3785)]).then(__webpack_require__.bind(__webpack_require__, 65232));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65232)
            ];
        }
    }
});
var JobSnippetStyle;
(function(JobSnippetStyle) {
    JobSnippetStyle["FullWidth"] = "Full_Width";
    JobSnippetStyle["TwoOfThreeWidth"] = "One_Column";
    JobSnippetStyle["TwoColumns"] = "Two_Column";
    JobSnippetStyle["ThreeColumns"] = "Three_Column";
})(JobSnippetStyle || (JobSnippetStyle = {}));
var styleToGridColumn = function(style) {
    switch(style){
        case JobSnippetStyle.ThreeColumns:
            return 4;
        case JobSnippetStyle.TwoColumns:
            return 6;
        default:
            return 12;
    }
};
var JobSnippet = function(param) {
    var heading = param.heading, jobs = param.jobs, _layout = param.layout, layout = _layout === void 0 ? JobSnippetStyle.FullWidth : _layout;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cmsComponents_ChildrenContainer__WEBPACK_IMPORTED_MODULE_1__/* .CMSChildrenContainer */ .z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_JobSnippet_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container),
            children: jobs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_JobSnippet_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[layout],
                children: [
                    heading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_JobSnippet_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            children: heading
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        container: true,
                        spacing: 1,
                        children: jobs.map(function(i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                item: true,
                                xs: 12,
                                md: styleToGridColumn(layout),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(JobSnippetItem, {
                                    data: i,
                                    style: layout
                                })
                            }, i.id);
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 88460:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"childrenContainer":"style_childrenContainer__d3pAq"};

/***/ }),

/***/ 14327:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JobSnippet_container__pm54_","title":"JobSnippet_title__W4wkR"};

/***/ })

}]);